import { render, staticRenderFns } from "./repairCategory.vue?vue&type=template&id=05714234&scoped=true"
import script from "./repairCategory.vue?vue&type=script&lang=js"
export * from "./repairCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05714234",
  null
  
)

export default component.exports